module.exports = __webpack_public_path__ + "img/zlhyjjfa_banner_img.78ce14c0.png";